import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const IconButton = ({styleName, onClick, children, disabled, ariaLabel}) => (
  <div className="IconButton">
    <button
      className={classNames("IconButton__button", {
        "IconButton--disabled": disabled,
      })}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <span className="IconButton__contents">
        <div
          className={classNames("IconButton__icon", styleName, {
            "IconButton--disabled": disabled,
          })}
        />
        {children}
      </span>
    </button>
  </div>
);

IconButton.propTypes = {
  styleName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  disabled: false,
};

const mapStateToProps = (state) => ({

});

export { IconButton };
export default connect(mapStateToProps)(IconButton);



// WEBPACK FOOTER //
// ./src/components/IconButton.js